'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_prelude_AppCurrency$$anon$2() {
}
export { $c_Lapp_prelude_AppCurrency$$anon$2 as $c_Lapp_prelude_AppCurrency$$anon$2 };
$p = $c_Lapp_prelude_AppCurrency$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lapp_prelude_AppCurrency$$anon$2;
/** @constructor */
function $h_Lapp_prelude_AppCurrency$$anon$2() {
}
export { $h_Lapp_prelude_AppCurrency$$anon$2 as $h_Lapp_prelude_AppCurrency$$anon$2 };
$h_Lapp_prelude_AppCurrency$$anon$2.prototype = $p;
$p.h = (function(x) {
  return x.av0();
});
var $d_Lapp_prelude_AppCurrency$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_prelude_AppCurrency$$anon$2, "app.prelude.AppCurrency$$anon$2", ({
  Ic: 1,
  bL: 1,
  f: 1
}));
export { $d_Lapp_prelude_AppCurrency$$anon$2 as $d_Lapp_prelude_AppCurrency$$anon$2 };
//# sourceMappingURL=app.prelude.-App-Currency$$anon$2.js.map
